var _path, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgButtonOverflow = function SvgButtonOverflow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#E4E6EB",
    d: "M8 .5h26A7.5 7.5 0 0 1 41.5 8v26a7.5 7.5 0 0 1-7.5 7.5H8A7.5 7.5 0 0 1 .5 34V8l.01-.386A7.5 7.5 0 0 1 7.614.51z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 15.6,
    r: 1.7,
    fill: "#383838"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 1.7,
    fill: "#383838"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 26.4,
    r: 1.7,
    fill: "#383838"
  })));
};
export default SvgButtonOverflow;